export const AUTH = "AUTH";
export const LOGGED_IN = "LOGGED_IN";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_VENDOR_DETAILS = "SET_VENDOR_DETAILS";
export const SET_LOGOUT_USER_ID = "SET_LOGOUT_USER_ID";
export const REMOVE_LOGOUT_USER_ID = "REMOVE_LOGOUT_USER_ID";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_WITHOUT_API = "LOGOUT_USER_WITHOUT_API";
export const SET_VEHICLE_LIST = "SET_VEHICLE_LIST";
export const SET_MATERIAL_LIST = "SET_MATERIAL_LIST";
export const CLEAN_STATE = "CLEAN_STATE";
